import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Select, SelectProps as AntdSelectProps } from "antd";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { SizeHeightMappings } from "@type/sizing";

export const StyledSelectWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const getDefaultClassCss = (size, mode) => {
    const token = useEnigmaToken();
    return css`
        border-radius: ${token.borderRadiusSM}px;
        font-size: ${token.fontSize}px;
        min-height: ${SizeHeightMappings[size]};
        padding-left: ${mode === "tags" && "8px"};
    `;
};

export const StyledSelect = styled(Select)<AntdSelectProps>`
    width: 100%;

    &&.enigma-select-default > div {
        ${({ size, mode }) => getDefaultClassCss(size, mode)};
    }

    .ant-select-selection-item.ant-select-selection-item {
        margin-inline-end: 8px;
        padding-right: 8px;
    }
`;

const getScrollBarCSS = () => {
    const token = useEnigmaToken();
    return css`
        .rc-virtual-list-scrollbar {
            padding: 4px;
            > div {
                background: ${token.color?.bg?.fill?.fillSubtle} !important;
                width: 8px !important;
            }
        }
    `;
};

export const StyledDropdown = styled.div`
    .ant-select-item {
        border-radius: 0;
        display: flex;
        align-items: center;
    }
    ${() => getScrollBarCSS()};
`;
